module.exports = __webpack_public_path__ + "static/media/logo.375777a2.svg";